const impersonationUidKeyName = 'impersonationUid';

export const isImpersonating = () => {
  return sessionStorage.getItem(impersonationUidKeyName) !== null;
};

export const getImpersonationUid = () => {
  return sessionStorage.getItem(impersonationUidKeyName);
};

export const setImpersonationUid = (id: string) => {
  return sessionStorage.setItem(impersonationUidKeyName, id);
};

export const clearImpersonationStorage = () => {
  sessionStorage.removeItem(impersonationUidKeyName);
};
